import * as svg from "../../../assets/link-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const LinkIcon = iconBuilder(svg, "LinkIcon", "0 0 12 13");
